import { TradingType, TransferStatus } from 'common/api/autogenerated/client-area';

import { SpotSocketConfigType } from 'common/hooks/useStream/types';

import { DerivativeSocketConfigType } from 'views/derivatives/types';

export enum CustomerInvokeEnum {
  CUSTOMER_HUB_EVENT = 'ReceiveMessage',
  TRANSFER_STATUS_UPDATED = 'TransferStatusUpdated',
}

export type SignalrInvokeType = SpotSocketConfigType | DerivativeSocketConfigType;

export type AssetDTOStream = {
  createdOn: string;
  price: number;
  priceQuotation: string;
  symbol: string;
  version: number;
};

export type CustomerBalanceUpdatedDto = {
  customerId: number;
  currency: string;
  availableBalance: number;
  availableBalanceUsd: number;
  totalBalance: number;
  totalBalanceUsd: number;
  messageId: 'CustomerBalanceUpdated';
  tradingType: TradingType;
};

export type AccountTransactionEventDto = {
  action?: 'Deposit' | 'Withdrawal' | 'WithdrawalRequest';
  originTransactionId?: string;
  status?: 'Completed' | 'Failed';
  currencyType?: 'crypto' | 'fiat';
  statusDescription?: string;
  customerId?: number;
  amount?: number;
  currency?: string;
  messageId?: string;
};

export type SignalRTransferUpdatedEventDto = {
  transferId: number;
  status: TransferStatus;
  currency: string;
  sourceAccountType: TradingType;
  destinationAccountType: TradingType;
  amount: number;
};
